import * as _ from 'lodash';
import { IMapper } from '../interfaces/mappers/mapper';

export abstract class SimpleMapper<I, O> implements IMapper<I, O> {
    protected toDTOFields: string[];
    protected fromDTOFields: string[];
    protected entityConstructor?: any;

    constructor() {}

    toDTO(model: I): O {
        if (!model) {
            return null;
        }
        return (_.pick(model, this.toDTOFields || this.fromDTOFields) as any) as O;
    }

    fromDTO(dto: O, params?: any): I {
        if (!dto) {
            return null;
        }
        const model = (_.pick(dto, this.fromDTOFields || this.toDTOFields) as any) as I;
        return this.entityConstructor ? new this.entityConstructor(model, params) : model;
    }
}
